import { routes } from 'constants/routes'
import WsNotifications from 'hooks/WsNotifications/WsNotifications'
import NoMatch from 'pages/NoMatch/NoMatch'
import { Route, Routes, useLocation } from 'react-router-dom'
import { isPublicCertificatePath } from 'utils/publicCertificatePath'
import {
  ToastProvider,
  ConfirmProvider,
  CommandPalette,
  InstallPrompt,
} from 'components/UnvUI'

function App() {
  const location = useLocation()
  const publicCertificate = isPublicCertificatePath(location.pathname)
  return (
    <ToastProvider>
      <ConfirmProvider>
        <div className="app">
          <Routes>
            {routes.map((route) => (
              <Route key={route.path} path={route.path} element={route.component} />
            ))}
            <Route path="*" element={<NoMatch />} />
          </Routes>
          {!publicCertificate && <WsNotifications />}
          {!publicCertificate && <CommandPalette />}
          {!publicCertificate && <InstallPrompt />}
        </div>
      </ConfirmProvider>
    </ToastProvider>
  )
}

export default App
